

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'

import router from './router/index'
import store from './store'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(VueRouter)









FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js